"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
function getImportanceOptions() {
    return [
        { value: 'High', text: owa_options_strings_1.default.options_inboxRules_high },
        { value: 'Normal', text: owa_options_strings_1.default.options_inboxRules_normal },
        { value: 'Low', text: owa_options_strings_1.default.options_inboxRules_low },
    ];
}
exports.default = getImportanceOptions;
//# sourceMappingURL=getImportanceOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getImportanceOptions.js
// module id = 5198
// module chunks = 2